import React, { useEffect,useMemo,useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, CONTENT_ID_SELECTOR } from '@common-fe/common-fe';

import { BOOLEAN_STRINGS } from '@/common/constants';
import ROUTES from '@/common/routes';
import { useBreadcrumbs } from '@/modules/core/hooks';
import ContributionEmployeesSettings from '@/modules/employer/components/ContributionEmployeesSettings/ContributionEmployeesSettings';

const MIN_SCROLL = 50;

const SetUpContributionPage = () => {
  const { isCreatingFromTemplate } = useParams<{ isCreatingFromTemplate?: string }>();
  const isFromTemplate = useMemo(() => isCreatingFromTemplate === BOOLEAN_STRINGS.TRUE, [isCreatingFromTemplate]);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const appContainer = document.getElementById(CONTENT_ID_SELECTOR);
    const updateScrolling = () => setIsScrolled(Boolean(appContainer && appContainer.scrollTop > MIN_SCROLL));

    appContainer?.addEventListener('scroll', updateScrolling);

    return () => {
      setIsScrolled(false);
      appContainer?.removeEventListener('scroll', updateScrolling);
    };
  }, []);
  useBreadcrumbs([
    {
      route: ROUTES.CONTRIBUTIONS,
      title: 'Contributions',
    },
    {
      route: ROUTES.SET_UP_CONTRIBUTION(isFromTemplate),
      title: 'Set up Contribution',
    },
  ]);
  return (
    <Box align="center" width="100%">
      <ContributionEmployeesSettings
        isScrolled={isScrolled}
        isCreatingFromTemplate={isFromTemplate}
      />
    </Box>
  );
};

export default SetUpContributionPage;
